var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column orders-collecting" },
    [
      _c(
        "b-container",
        {
          staticClass: "flex-grow-1 d-flex flex-column h-100",
          attrs: { fluid: "" }
        },
        [
          _c(
            "b-row",
            { staticClass: "flex-grow-1" },
            [
              _c(
                "b-col",
                { staticClass: "d-flex flex-column h-100", attrs: { md: "3" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "flex-grow-1",
                      attrs: {
                        "no-body": "",
                        "header-class": "py-2",
                        header: "<b>Заказы:</b>"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("b", [_vm._v("Заказы:")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("el-button", {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle.collapseOrders",
                                    modifiers: { collapseOrders: true }
                                  }
                                ],
                                staticClass: "no-outline",
                                attrs: {
                                  icon: "el-icon-search",
                                  size: "medium",
                                  circle: ""
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        { attrs: { id: "collapseOrders" } },
                        [
                          _c(
                            "b-list-group",
                            { attrs: { flush: "" } },
                            [
                              _c(
                                "b-list-group-item",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-1",
                                      attrs: { horizontal: "", label: "Поиск" }
                                    },
                                    [
                                      _c(
                                        "b-input-group",
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              placeholder: "Введите № чека"
                                            },
                                            model: {
                                              value: _vm.filterOrders,
                                              callback: function($$v) {
                                                _vm.filterOrders = $$v
                                              },
                                              expression: "filterOrders"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  attrs: {
                                                    disabled: !_vm.filterOrders
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.filterOrders = ""
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Очистить\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "mb-0",
                                      attrs: { horizontal: "", label: "Статус" }
                                    },
                                    [
                                      _c(
                                        "b-form-select",
                                        {
                                          attrs: {
                                            options: _vm.selectStatuses
                                          },
                                          model: {
                                            value: _vm.filterStatus,
                                            callback: function($$v) {
                                              _vm.filterStatus = $$v
                                            },
                                            expression: "filterStatus"
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { slot: "first" },
                                              domProps: { value: null },
                                              slot: "first"
                                            },
                                            [_vm._v("-- Все --")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "perfect-scrollbar",
                        {
                          staticClass: "flex-grow-1 flex-basis-0",
                          attrs: { options: _vm.opsScroll }
                        },
                        [
                          _c(
                            "b-list-group",
                            { attrs: { flush: "" } },
                            [
                              _vm.orders.length === 0
                                ? _c(
                                    "b-card-body",
                                    { staticClass: "text-center" },
                                    [
                                      _vm._v(
                                        "Заказов не найдено\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.orders, function(ord) {
                                return _c(
                                  "b-list-group-item",
                                  {
                                    key: ord.id,
                                    class: [
                                      "order",
                                      {
                                        activeIt: _vm.selectedOrderId === ord.id
                                      }
                                    ],
                                    on: {
                                      click: function($event) {
                                        return _vm.changeSelectedOrder(ord)
                                      }
                                    }
                                  },
                                  [
                                    _c("order-block", {
                                      attrs: {
                                        order: ord,
                                        type: "collector",
                                        "order-stages": _vm.orderStagesObj
                                      }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex flex-column", attrs: { md: "9" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "flex-grow-1 d-flex flex-column",
                      attrs: {
                        "no-body": "",
                        "header-class": "py-2",
                        header: "<b>Заказы:</b>"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c("b", [_vm._v("Товары:")]),
                          _vm._v(" "),
                          _vm.selectedOrder && _vm.products.length
                            ? _c(
                                "b-btn",
                                {
                                  attrs: { variant: "success" },
                                  on: {
                                    click: function($event) {
                                      return _vm.printCheck()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Напечатать чек (" +
                                      _vm._s(
                                        _vm.selectedOrder.timesPrinted + 1
                                      ) +
                                      ")\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.selectedOrderId
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-grow-1 text-center d-flex flex-column justify-content-center"
                            },
                            [_c("div", [_vm._v("Сначала выберите заказ")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedOrderId
                        ? _c(
                            "perfect-scrollbar",
                            {
                              staticClass: "flex-grow-1",
                              attrs: { options: _vm.opsScroll }
                            },
                            [
                              _c("b-table", {
                                staticClass: "mb-0 table-orders",
                                attrs: {
                                  hover: "",
                                  "show-empty": "",
                                  "empty-text": _vm.emptyTextProds,
                                  fields: _vm.fields,
                                  items: _vm.products,
                                  "tbody-class": "scroll-y",
                                  "tbody-tr-class": "order-prods"
                                },
                                on: { "row-clicked": _vm.rowClicked },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "table-colgroup",
                                      fn: function(scope) {
                                        return _vm._l(scope.fields, function(
                                          field
                                        ) {
                                          return _c("col", {
                                            key: field.key,
                                            style: {
                                              width: field.width || "auto"
                                            }
                                          })
                                        })
                                      }
                                    },
                                    {
                                      key: "accept",
                                      fn: function(data) {
                                        return [
                                          !data.item.deleted
                                            ? _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    name:
                                                      "accept" + data.item.id,
                                                    value: true,
                                                    "unchecked-value": false
                                                  },
                                                  model: {
                                                    value: data.item.collected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        data.item,
                                                        "collected",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "data.item.collected"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  собрано\n                "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    },
                                    {
                                      key: "cost",
                                      fn: function(data) {
                                        return [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                data.item.cost > 0
                                                  ? data.item.cost + " ₽"
                                                  : data.item.pricePoints + " Б"
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "nameProd",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              attrs: {
                                                id:
                                                  "orderProd" + data.item.index
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "description" },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.brandsMap.get(
                                                          data.item.idBrand
                                                        ) +
                                                          " - " +
                                                          data.item.name
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                data.item.groupProds,
                                                function(add) {
                                                  return _c(
                                                    "b-badge",
                                                    {
                                                      key: add.id,
                                                      staticClass: "mr-1"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(add.name) +
                                                          _vm._s(
                                                            add.cost > 0
                                                              ? " (" +
                                                                  add.cost +
                                                                  " ₽)"
                                                              : ""
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("b-tooltip", {
                                            attrs: {
                                              target:
                                                "orderProd" + data.item.index,
                                              container: "orderProd",
                                              title: data.item.description
                                            }
                                          })
                                        ]
                                      }
                                    },
                                    {
                                      key: "countNum",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "text-success h5" },
                                            [
                                              _vm._v(
                                                "x " +
                                                  _vm._s(data.item.count) +
                                                  " шт"
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3579944378
                                )
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-shrink-0 justify-content-between"
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  my-2",
                              attrs: {
                                variant: "danger",
                                disabled: !_vm.selectedOrderId
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cancelCollect()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Не сохранять\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "flex-grow-1 ml-1  my-2",
                              attrs: {
                                variant: "success",
                                disabled:
                                  !_vm.selectedOrderId ||
                                  !_vm.permitChangeOrder ||
                                  !_vm.permitSave
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveChangesCollect()
                                }
                              }
                            },
                            [_vm._v("\n              Сохранить\n            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28ff74ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28ff74ed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrdersCollecting.vue
// module id = null
// module chunks = 